import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from '../index.module.scss'
import { selectOtherSetting } from '../store/slice'
import { SelectPopup } from './SelectPopup'

export const SelectPortfolio = () => {
  const isDisabled = useSelector(selectOtherSetting('disabled'))
  const isDefault = useSelector(selectOtherSetting('isDefault'))

  const disabled = isDisabled && !isDefault

  const [isShow, setIsShow] = useState(false)

  const showPopup = () => {
    if (disabled) return
    setIsShow(true)
  }

  const closePopup = () => {
    setIsShow(false)
  }

  return (
    <>
      <Element
        className={classes.selectPortfolio}
        style={{
          borderColor: '#D5D5D5',
          backgroundColor: disabled ? '#D5D5D5' : undefined,
          color: disabled ? '#9C9C9C' : '#3A414B',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={showPopup}
      >
        <Translate value="alertSetting.SELECT_PORTFOLIO" />
      </Element>

      {isShow && <SelectPopup closePopup={closePopup} />}
    </>
  )
}
